<template>
  <div class="w-full bg-white shadow-sm px-6 py-3">
    <div class="flex justify-between items-center lg:max-w-[1400px] lg:mx-auto">
      <!-- Left side: Logo and name -->
      <RouterLink :to="{ name: 'landing' }" class="flex items-center gap-2 cursor-pointer">
        <img v-if="!schoolLogo" :src="navLogo" :alt="`${appName} home`" class="h-24 w-auto -my-6 shrink-0 object-contain" />
        <img v-else :src="schoolLogo" alt="School Logo" class="h-12 w-auto shrink-0 object-contain" />
        <span class="text-xl font-semibold text-gray-800">{{ appName }}</span>
      </RouterLink>

      <!-- Right side: Dynamic button -->
      <Button
        v-if="!hideAction"
        :label="isLoginPage ? 'Login' : 'Login'"
        :icon="isLoginPage ? 'pi pi-user-plus' : 'pi pi-sign-in'"
        class="bg-primary px-4 py-2 rounded-md shadow-sm transition"
        @click="handleButtonClick"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useBranding } from '@/composables/useBranding';
import navLogo from '@/assets/svg/navlogo.png';

const props = defineProps<{
  hideAction?: boolean
}>();

const route = useRoute();
const router = useRouter();

const { appName, schoolLogo } = useBranding();

// Check if current route is login
const isLoginPage = computed(() => route.path === '/login');

// Handle button click
const handleButtonClick = () => {
  router.push('/login');
};
</script>

<style scoped>
/* Optional fine-tuning */
</style>
